import Vue from 'vue'
import App from './App'
import router from './router'
import { Checkbox, Radio, Dialog, Table } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import {
  getStorage
} from '@/common/utils/localStorage'
import 'babel-polyfill'
require('es6-promise').polyfill()
require('filereader-polyfill')

Vue.config.productionTip = false
Vue.config.debug = true

Vue.use(Checkbox)
Vue.use(Radio)
Vue.use(Dialog)
Vue.use(Table)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
  created() {
     this.checkLogin()
  },
  mounted(){
  },
  watch: {
    // '$route': 'checkLogin'
  },
  methods: {
    checkLogin() {
      let IS_LOGIN = false
      if (getStorage('ticket')) {
        IS_LOGIN =true
      }
      if (!IS_LOGIN) {
        this.$router.push('/login')
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js